import { ComputeContextKeys } from '../hooks/computeContext/const';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class -- needed
export class DependencyPaths {
  static dataSource(dataSourceId: string) {
    return {
      isLoading: `${dataSourceId}['isLoading']`,
      isFetching: `${dataSourceId}['isFetching']`,
      error: `${dataSourceId}['error']`,
      isFetchingNextPage: `${dataSourceId}['isFetchingNextPage']`,
      hasNextPage: `${dataSourceId}['hasNextPage']`,
      data: `${dataSourceId}['data']`,
      dataSourceMeta: `${ComputeContextKeys.DATA_SOURCES_META}['${dataSourceId}']`,
      aggregationMeta: {
        details: `${ComputeContextKeys.DATA_SOURCES_META}['${dataSourceId}']['aggregationMeta']`,
        isLoading: `${ComputeContextKeys.DATA_SOURCES_META}['${dataSourceId}']['aggregationMeta']['isLoading']`,
        data: `${ComputeContextKeys.DATA_SOURCES_META}['${dataSourceId}']['aggregationMetadata']['data']`,
      },
    };
  }

  static pageFunction(pageFunctionId: string) {
    return {
      value: `${pageFunctionId}['value']`,
      error: `${pageFunctionId}['error']`,
      isEvaluated: `${pageFunctionId}['isEvaluated']`,
    };
  }
}
